export default "__VITE_ASSET__CCC6OHSZ__"